import React from 'react';
import cx from 'classnames';

const isProd = process.env.NODE_ENV === 'production';
const gnbURL = isProd
  ? 'https://static.linetv.tw/mini-gnb/index.html'
  : 'https://static-beta.linetv.tw/mini-gnb/index.html';

export default function GNB({ className }) {
  return (
    <iframe
      src={gnbURL}
      frameBorder="0"
      className={cx('block w-full', className)}
      height="36"
      style={{ height: 'var(--gnb-height)', backgroundColor: '#2d3649' }}
    />
  );
}
